/**
 * Convierte un texto de UI ("Llamada de seguimiento") en un código interno
 * estilo `LLAMADA_DE_SEGUIMIENTO`:
 * - Quita acentos.
 * - Reemplaza no-alfanuméricos por guión bajo (sin colapsar dobles).
 * - Sube a mayúsculas.
 * - Elimina guiones bajos al inicio/fin.
 *
 * Uso típico: auto-completar el campo `name` mientras el usuario escribe en `label`.
 */
export function slugifyToCode(input: string): string {
  if (!input) return '';
  // Quitar acentos: NFD normaliza y combinable diacritics se borran
  const noAccents = input.normalize('NFD').replace(/[̀-ͯ]/g, '');
  return noAccents
    .trim()
    .replace(/[^a-zA-Z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '')
    .toUpperCase();
}
